import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box, Center, Grid } from '@chakra-ui/react';
import { RFNodeIcon, RFSvg } from '../../base';
import { useNodeTemplate } from '../../../hooks';
import { RFConfigContext } from '../../../contexts';
import { SEPARATOR_2PH_CONFIG } from './RFSeparator2phNode.config';
/**
 * Component renders "separator2ph" type of node of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_NODE_TYPES.
 */
const RFSeparator2phNodeFC = ({ id, data, type, isConnectable = true, selected }) => {
    const { isInspector } = useContext(RFConfigContext) ?? {};
    const { isValidTemplate, renderPorts, renderError } = useNodeTemplate({
        id,
        selected,
        templateCode: data.templateCode,
        config: SEPARATOR_2PH_CONFIG
    });
    return isValidTemplate ? (_jsxs(_Fragment, { children: [_jsxs(Grid, { "data-templateid": data.templateCode, templateColumns: "auto auto", gap: "8px", children: [_jsx(RFNodeIcon, { id: id, rfType: type, isSelected: selected, isInspector: isInspector, templateCode: data.templateCode ?? '', children: _jsx(RFSvg, { name: SEPARATOR_2PH_CONFIG.icon, width: 50, height: 152 }) }), _jsx(Center, { children: _jsx(Box, { maxW: "60px", fontSize: "12px", lineHeight: "14px", fontWeight: 700, className: "cut-text", children: data.title }) })] }), renderPorts(isConnectable, isInspector)] })) : (_jsx(_Fragment, { children: renderError() }));
};
export const RFSeparator2phNode = RFSeparator2phNodeFC;
//# sourceMappingURL=RFSeparator2phNode.js.map